import v20Schema, {
  MigrationTypes as V20Types,
} from '../client/schemaVersions/v20.js';
import v21Schema, {
  MigrationTypes as V21Types,
} from '../client/schemaVersions/v21.js';
import { createMigration } from '@verdant-web/store';

export default createMigration<V20Types, V21Types>(
  v20Schema,
  v21Schema,
  async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
  }
);
